
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import Checkbox from '@/common/components/UI/Checkbox/index.vue'
import RadioGroup from '@/common/components/UI/RadioGroup/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { integer, required, requiredIf } from '@vuelidate/validators'

// constants
import { FTL_PAYMENT_RATE_TYPES } from '@/core/constants/ftl_types.constants'
import { EnterCostPricePayloadT } from '@/core/types/ftl_bids.types'

export default defineComponent({
    components: {
        modal: Modal,
        TheInput,
        checkbox: Checkbox,
        RadioGroup,
    },
    emits: ['cancel', 'submitted'],
    props: {
        ftlType: {
            type: Number,
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isNeedCar: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const state = reactive({
            // cost_price_with_nds: 0 as number | 0,
            is_prepayment: false,
        })

        const rate_state = reactive({
            payment_rate_type_id: 2,
            cost_price: null as number | null,
        })

        const state_form$ = useVuelidate(
            {
                cost_price: { required: requiredIf(() => props.isNeedCar), integer },
            },
            rate_state
        )

        const isFTLTypeTwo = computed(() => props.ftlType === 2)

        const emitCancel = () => {
            emit('cancel')
        }

        const getPayload = () => {
            let payload: EnterCostPricePayloadT = { ...state }

            if (rate_state.payment_rate_type_id) {
                payload.payment_rate_type_id = rate_state.payment_rate_type_id

                if (rate_state.payment_rate_type_id === 1) {
                    payload.cost_price_per_hour = Number(rate_state.cost_price)
                } else if (rate_state.payment_rate_type_id === 2) {
                    payload.cost_price = Number(rate_state.cost_price)
                }
            } else {
                payload.cost_price = Number(rate_state.cost_price)
            }

            return payload
        }

        const emitSubmitted = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submitted', getPayload())
        }

        const getPlaceholder = computed(() => {
            let placeholder = 'Себестоимость '

            if (isFTLTypeTwo.value) {
                if (rate_state.payment_rate_type_id === 1) placeholder += ' за час'
                else if (rate_state.payment_rate_type_id === 2) placeholder += ' за рейс'
            }

            return placeholder
        })

        onBeforeMount(() => {
            if (isFTLTypeTwo.value) rate_state.payment_rate_type_id = 2
        })

        return {
            state,
            rate_state,
            //
            state_form$,
            emitCancel,
            emitSubmitted,
            //
            getPlaceholder,
            isFTLTypeTwo,
            //
            FTL_PAYMENT_RATE_TYPES,
        }
    },
})
